var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCandidatesMenuIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_98444",
    "data-name": "Group 98444",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.442,
    height: 17,
    viewBox: "0 0 17.442 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27939142"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3229",
    "data-name": "Rectangle 3229",
    width: 17.442,
    height: 17,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10085",
    "data-name": "Group 10085",
    clipPath: "url(#clip-path-27939142)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13077",
    "data-name": "Path 13077",
    d: "M5.483,9.263a3.249,3.249,0,0,1-3.29-3.206A3.249,3.249,0,0,1,5.483,2.85a3.249,3.249,0,0,1,3.29,3.206,3.253,3.253,0,0,1-3.29,3.206m0-4.988A1.782,1.782,0,1,0,7.311,6.057,1.8,1.8,0,0,0,5.483,4.275m5.483,12.113v-.356a5.415,5.415,0,0,0-5.483-5.344A5.415,5.415,0,0,0,0,16.032v.356a.722.722,0,0,0,.731.713.722.722,0,0,0,.731-.713v-.356a3.971,3.971,0,0,1,4.021-3.919A3.971,3.971,0,0,1,9.5,16.032v.356a.731.731,0,0,0,1.462,0m6.58-3.563a5.054,5.054,0,0,0-5.118-4.988,5.194,5.194,0,0,0-3.412,1.27.7.7,0,0,0-.067,1.006.744.744,0,0,0,1.032.065l.01-.009a3.722,3.722,0,0,1,5.161.281,3.512,3.512,0,0,1,.931,2.375.731.731,0,0,0,1.462,0M12.794,6.413A3.249,3.249,0,0,1,9.5,3.206a3.291,3.291,0,0,1,6.58,0,3.252,3.252,0,0,1-3.29,3.206m0-4.988a1.8,1.8,0,0,0-1.828,1.781,1.828,1.828,0,0,0,3.655,0,1.8,1.8,0,0,0-1.828-1.781",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandidatesMenuIcon);
export default __webpack_public_path__ + "static/media/candidates-menu-icon.9e27005a7d134caaa6432a7e4551696c.svg";
export { ForwardRef as ReactComponent };